import { ISelectOptions, ITimeOptionType } from './models';
import {
  TDoctorTypes,
  TPatientHealthStatus,
  TPatientStatus,
  TUserTypes
} from './types';

export const TIMEZONES: ISelectOptions[] = [
  {
    value: 'Australia/Eucla',
    label: '(GMT+8:45) Eucla'
  },
  {
    value: 'Australia/Perth',
    label: '(GMT+8:00) AWST - Perth'
  },
  {
    value: 'Australia/Darwin',
    label: '(GMT+9:30) ACST - Darwin'
  },
  {
    value: 'Australia/Brisbane',
    label: '(GMT+10:00) AEST - Brisbane'
  },
  {
    value: 'Australia/Lindeman',
    label: '(GMT+10:00) AEST - Lindeman'
  },
  {
    value: 'Australia/Adelaide',
    label: '(GMT+10:30) ACDT - Adelaide'
  },
  {
    value: 'Australia/Broken_Hill',
    label: '(GMT+10:30) ACDT - Broken Hill'
  },
  {
    value: 'Australia/Hobart',
    label: '(GMT+11:00) AEDT - Hobart'
  },
  {
    value: 'Australia/Melbourne',
    label: '(GMT+11:00) AEDT - Melbourne'
  },
  {
    value: 'Australia/Sydney',
    label: '(GMT+11:00) AEDT - Sydney'
  }
];

export const GENDER_OPTIONS: ISelectOptions[] = [
  {
    value: 'MALE',
    label: 'Male'
  },
  {
    value: 'FEMALE',
    label: 'Female'
  },
  {
    value: 'NOTTOSAY',
    label: 'Preferred not to say'
  },
  {
    value: 'OTHERS',
    label: 'Other'
  }
];

export const CONDITIONS: string[] = [
  'Endometriosis',
  'Menopause or Perimenopause',
  'PCOS',
  'Interstitial cystitis',
  'Adenomyosis',
  'Recurrent urinary tract infection',
  'Period pain (Dysmenorrhoea)',
  'Sexually transmitted infection',
  'Premenstrual syndrome (PMS)',
  'Hormonal imbalances',
  'Vaginal & vulvar pain',
  'Chronic thrush or bacterial vaginosis',
  'Painful sex (Dyspareunia)',
  'Pelvic inflammatory disease',
  'Premenstrual dysphoric disorder'
];

export const TIME_OPTIONS: ITimeOptionType[] = [
  {
    label: '12:00 AM',
    value: '00:00'
  },
  {
    label: '12:30 AM',
    value: '00:30'
  },
  {
    label: '01:00 AM',
    value: '01:00'
  },
  {
    label: '01:30 AM',
    value: '01:30'
  },
  {
    label: '02:00 AM',
    value: '02:00'
  },
  {
    label: '02:30 AM',
    value: '02:30'
  },
  {
    label: '03:00 AM',
    value: '03:00'
  },
  {
    label: '03:30 AM',
    value: '03:30'
  },
  {
    label: '04:00 AM',
    value: '04:00'
  },
  {
    label: '04:30 AM',
    value: '04:30'
  },
  {
    label: '05:00 AM',
    value: '05:00'
  },
  {
    label: '05:30 AM',
    value: '05:30'
  },
  {
    label: '06:00 AM',
    value: '06:00'
  },
  {
    label: '06:30 AM',
    value: '06:30'
  },
  {
    label: '07:00 AM',
    value: '07:00'
  },
  {
    label: '07:30 AM',
    value: '07:30'
  },
  {
    label: '08:00 AM',
    value: '08:00'
  },
  {
    label: '08:30 AM',
    value: '08:30'
  },
  {
    label: '09:00 AM',
    value: '09:00'
  },
  {
    label: '09:30 AM',
    value: '09:30'
  },
  {
    label: '10:00 AM',
    value: '10:00'
  },
  {
    label: '10:30 AM',
    value: '10:30'
  },
  {
    label: '11:00 AM',
    value: '11:00'
  },
  {
    label: '11:30 AM',
    value: '11:30'
  },
  {
    label: '12:00 PM',
    value: '12:00'
  },
  {
    label: '12:30 PM',
    value: '12:30'
  },
  {
    label: '01:00 PM',
    value: '13:00'
  },
  {
    label: '01:30 PM',
    value: '13:30'
  },
  {
    label: '02:00 PM',
    value: '14:00'
  },
  {
    label: '02:30 PM',
    value: '14:30'
  },
  {
    label: '03:00 PM',
    value: '15:00'
  },
  {
    label: '03:30 PM',
    value: '15:30'
  },
  {
    label: '04:00 PM',
    value: '16:00'
  },
  {
    label: '04:30 PM',
    value: '16:30'
  },
  {
    label: '05:00 PM',
    value: '17:00'
  },
  {
    label: '05:30 PM',
    value: '17:30'
  },
  {
    label: '06:00 PM',
    value: '18:00'
  },
  {
    label: '06:30 PM',
    value: '18:30'
  },
  {
    label: '07:00 PM',
    value: '19:00'
  },
  {
    label: '07:30 PM',
    value: '19:30'
  },
  {
    label: '08:00 PM',
    value: '20:00'
  },
  {
    label: '08:30 PM',
    value: '20:30'
  },
  {
    label: '09:00 PM',
    value: '21:00'
  },
  {
    label: '09:30 PM',
    value: '21:30'
  },
  {
    label: '10:00 PM',
    value: '22:00'
  },
  {
    label: '10:30 PM',
    value: '22:30'
  },
  {
    label: '11:00 PM',
    value: '23:00'
  },
  {
    label: '11:30 PM',
    value: '23:30'
  }
];

export const TIME_OPTIONS_15: ITimeOptionType[] = [
  {
    label: '07:00 AM',
    value: '07:00'
  },
  {
    label: '07:15 AM',
    value: '07:15'
  },
  {
    label: '07:30 AM',
    value: '07:30'
  },
  {
    label: '07:45 AM',
    value: '07:45'
  },
  {
    label: '08:00 AM',
    value: '08:00'
  },
  {
    label: '08:15 AM',
    value: '08:15'
  },
  {
    label: '08:30 AM',
    value: '08:30'
  },
  {
    label: '08:45 AM',
    value: '08:45'
  },
  {
    label: '09:00 AM',
    value: '09:00'
  },
  {
    label: '09:15 AM',
    value: '09:15'
  },
  {
    label: '09:30 AM',
    value: '09:30'
  },
  {
    label: '09:45 AM',
    value: '09:45'
  },
  {
    label: '10:00 AM',
    value: '10:00'
  },
  {
    label: '10:15 AM',
    value: '10:15'
  },
  {
    label: '10:30 AM',
    value: '10:30'
  },
  {
    label: '10:45 AM',
    value: '10:45'
  },
  {
    label: '11:00 AM',
    value: '11:00'
  },
  {
    label: '11:15 AM',
    value: '11:15'
  },
  {
    label: '11:30 AM',
    value: '11:30'
  },
  {
    label: '11:45 AM',
    value: '11:45'
  },
  {
    label: '12:00 PM',
    value: '12:00'
  },
  {
    label: '12:15 PM',
    value: '12:15'
  },
  {
    label: '12:30 PM',
    value: '12:30'
  },
  {
    label: '12:45 PM',
    value: '12:45'
  },
  {
    label: '01:00 PM',
    value: '13:00'
  },
  {
    label: '01:15 PM',
    value: '13:15'
  },
  {
    label: '01:30 PM',
    value: '13:30'
  },
  {
    label: '01:45 PM',
    value: '13:45'
  },
  {
    label: '02:00 PM',
    value: '14:00'
  },
  {
    label: '02:15 PM',
    value: '14:15'
  },
  {
    label: '02:30 PM',
    value: '14:30'
  },
  {
    label: '02:45 PM',
    value: '14:45'
  },
  {
    label: '03:00 PM',
    value: '15:00'
  },
  {
    label: '03:15 PM',
    value: '15:15'
  },
  {
    label: '03:30 PM',
    value: '15:30'
  },
  {
    label: '03:45 PM',
    value: '15:45'
  },
  {
    label: '04:00 PM',
    value: '16:00'
  },
  {
    label: '04:15 PM',
    value: '16:15'
  },
  {
    label: '04:30 PM',
    value: '16:30'
  },
  {
    label: '04:45 PM',
    value: '16:45'
  },
  {
    label: '05:00 PM',
    value: '17:00'
  },
  {
    label: '05:15 PM',
    value: '17:15'
  },
  {
    label: '05:30 PM',
    value: '17:30'
  },
  {
    label: '05:45 PM',
    value: '17:45'
  },
  {
    label: '06:00 PM',
    value: '18:00'
  },
  {
    label: '06:15 PM',
    value: '18:15'
  },
  {
    label: '06:30 PM',
    value: '18:30'
  },
  {
    label: '06:45 PM',
    value: '18:45'
  },
  {
    label: '07:00 PM',
    value: '19:00'
  },
  {
    label: '07:30 PM',
    value: '19:30'
  },
  {
    label: '08:00 PM',
    value: '20:00'
  },
  {
    label: '08:15 PM',
    value: '20:15'
  },
  {
    label: '08:30 PM',
    value: '20:30'
  },
  {
    label: '08:45 PM',
    value: '20:45'
  },
  {
    label: '09:00 PM',
    value: '21:00'
  },
  {
    label: '09:15 PM',
    value: '21:15'
  },
  {
    label: '09:30 PM',
    value: '21:30'
  },
  {
    label: '09:45 PM',
    value: '21:45'
  },
  {
    label: '10:00 PM',
    value: '22:00'
  },
  {
    label: '10:15 PM',
    value: '22:15'
  },
  {
    label: '10:30 PM',
    value: '22:30'
  },
  {
    label: '10:45 PM',
    value: '22:45'
  },
  {
    label: '11:00 PM',
    value: '23:00'
  }
];

export const TABLE_PER_PAGE: ISelectOptions[] = [
  {
    label: '5 per page',
    value: 5
  },
  {
    label: '10 per page',
    value: 10
  },
  {
    label: '20 per page',
    value: 20
  },
  {
    label: '25 per page',
    value: 25
  },
  {
    label: '50 per page',
    value: 50
  },
  {
    label: '100 per page',
    value: 100
  }
];

export const PRESCRIPTION_STATUS_TOKEN = {
  PENDING: {
    tokenBg: 'bg-red'
  },
  ACTIVE: {
    tokenBg: 'bg-green'
  },
  INVOICED: {
    tokenBg: 'bg-green'
  },
  PAID: {
    tokenBg: 'bg-green'
  },
  READY_FOR_DISPENSING: {
    tokenBg: 'bg-green'
  },
  OVERDUE: {
    tokenBg: 'bg-red'
  },
  DISPENSING: {
    tokenBg: 'bg-yellow'
  },
  DISPENSED: {
    tokenBg: 'bg-blue'
  },
  SHIPPING: {
    tokenBg: 'bg-yellow'
  },
  DELIVERED: {
    tokenBg: 'bg-green'
  },
  INACTIVE: {
    tokenBg: 'bg-red'
  },
  EXPIRED: {
    tokenBg: 'bg-red'
  },
  EXPORTED: {
    tokenBg: 'bg-blue'
  },
  TRANSFERRED: {
    tokenBg: 'bg-blue'
  }
};

export const DEFAULT_TIMEZONE = 'Australia/Adelaide';

export const CONSULTATION_STATUS: ISelectOptions[] = [
  {
    label: 'Precall',
    value: 'PRECALL'
  },
  {
    label: 'On call',
    value: 'ONCALL'
  },
  {
    label: 'Call end',
    value: 'CALLEND'
  },
  {
    label: 'Postcall',
    value: 'POSTCALL'
  },
  {
    label: 'Cancel',
    value: 'CANCEL'
  },
  {
    label: 'Completed',
    value: 'DONE'
  },
  {
    label: 'Did not attend',
    value: 'DIDNOTATTEND'
  }
];

export const CONSULTATION_TYPE = [
  'Initial Consultation',
  'Standard Consultation',
  'Short Consultation'
];

export const STATE_OPTIONS: ISelectOptions[] = [
  { label: 'ACT', value: 'ACT' },
  { label: 'NSW', value: 'NSW' },
  { label: 'NT', value: 'NT' },
  { label: 'QLD', value: 'QLD' },
  { label: 'SA', value: 'SA' },
  { label: 'TAS', value: 'TAS' },
  { label: 'VIC', value: 'VIC' },
  { label: 'WA', value: 'WA' }
];

export const EMERGENCY_RELATIONSHIP: ISelectOptions[] = [
  { label: 'Spouse', value: 'Spouse' },
  { label: 'Parent', value: 'Parent' },
  { label: 'Children', value: 'Children' },
  { label: 'Sibling', value: 'Sibling' },
  { label: 'Aunt/Uncle', value: 'Aunt/Uncle' },
  { label: 'Grandparent', value: 'Grandparent' },
  { label: 'Friend', value: 'Friend' }
];

export const CONSULTATION_STATUS_CX = {
  PENDING: {
    name: 'Pending',
    className: 'bg-[#FFF8D6] text-[#8B6914]'
  },
  PRECALL: {
    name: 'Precall',
    className: 'bg-[#E8F0E8] text-[#2D6A4F]'
  },
  POSTCALL: {
    name: 'Postcall',
    className: 'bg-[#D1E8E4] text-[#1B4F45]'
  },
  CALLEND: {
    name: 'Call ended',
    className: 'bg-[#FAE8E0] text-[#8B3A1E]'
  },
  DONE: {
    name: 'Completed',
    className: 'bg-[#D6EEE8] text-[#0F5342]'
  },
  DIDNOTATTEND: {
    name: 'Did Not Attend',
    className: 'bg-[#F5E6E8] text-[#8B2635]'
  },
  CANCEL: {
    name: 'Cancelled',
    className: 'bg-[#F0EDE8] text-[#6B6560]'
  },
  BLOCK: {
    name: 'Blocked',
    className: 'bg-[#E8E5E0] text-[#4A4540]'
  },
  DELETED: {
    name: 'Deleted',
    className: 'bg-[#E0DDD8] text-[#3A3530]'
  },
  UNPAID: {
    name: 'Unpaid',
    className: 'bg-[#FDECD8] text-[#8B4513]'
  },
  ONCALL: {
    name: 'On call',
    className: 'bg-[#0F5342] text-white'
  }
};

export const ESCRIPT_STATUS = [
  'PENDING',
  'ACTIVE',
  'INVOICED',
  'PAID',
  'READY_FOR_DISPENSING',
  'DISPENSING',
  'DISPENSED',
  'SHIPPING',
  'DELIVERED',
  'CANCELLED',
  'INACTIVE'
];

export const SCRIPT_STATUS = [
  'PENDING',
  'ACTIVE',
  'READY_FOR_DISPENSING',
  'COMPLETED',
  'INACTIVE',
  'EXPIRED',
  'EXPORTED',
  'TRANSFERRED'
];

export const ESCRIPT_TOKEN_STATUS = [
  'PENDING',
  'ACTIVE',
  'INVOICED',
  'PAID',
  'READY_FOR_DISPENSING',
  'OVERDUE',
  'DISPENSING',
  'DISPENSED',
  'SHIPPING',
  'DELIVERED',
  'INACTIVE',
  'EXPIRED',
  'EXPORTED',
  'TRANSFERRED'
];

export const IS_DEV = ['development', 'qa', 'staging'];

export const USER_TYPES: TUserTypes[] = [
  'patient_access',
  'doctor_access',
  'consultation_access',
  'product_access',
  'prescription_access',
  'coupon_access',
  'reset_consultation_access',
  'generate_prescription_access',
  'reschedule_access',
  'did_not_attend_access',
  'cancel_access',
  'consultation_logs_access',
  'login_patient_access',
  'login_doctor_access'
  // 'update_wallet_access',
  // 'dispensing_limit_access',
  // 'dispensing_interval_access'
];

export const DOCTOR_TYPES: TDoctorTypes[] = [
  'has_lifestyle',
  'has_naturopathy',
  'has_nutrition',
  'has_mental',
  'has_sexual'
];

export const DOCTOR_ACCESS: string[] = [
  'has_prescriptions',
  'has_supplements',
  'has_referrals'
  //   'has_careplan',
  //   'has_journals'
];

export const PATIENT_STATUS_OPTIONS: TPatientStatus[] = [
  'ACTIVE',
  'DORMANT',
  'DISCHARGED',
  'BOOKED',
  'PENDING',
  'INACTIVE'
];

export const PATIENT_HEALTH_STATUS_OPTIONS: TPatientHealthStatus[] = ['PENDING', 'DONE'];

export const COMMUNICATION_PREFERENCE_OPTIONS: string[] = ['AUDIO', 'VIDEO', 'PHONE'];

export const ORDER_STATUS_PROCESSING = [
  'PROCESSING',
  'PENDING',
  'ACTIVE',
  'INVOICED',
  'PAID',
  'READY_FOR_DISPENSING',
  'DISPENSING',
  'DELAYED'
];

export const ORDER_STATUS_SHIPPED = ['DISPENSED', 'SHIPPING'];

export const ORDER_STATUS_COMPLETED = ['DELIVERED', 'COMPLETED'];

export const ORDER_STATUS_HOLD = ['INACTIVE', 'PAYMENT_FAILED', 'ON_HOLD'];

export const ORDER_STATUS_CANCELLED = ['CANCELLED'];

export const ORDER_STATUS_REVIEW = ['REVIEW'];

export const SHIPPING_FEE = 15;

export const REFUND_REASONS = [
  'Product Discontinued',
  'Product not avail',
  'Faulty Product',
  'Expired/Short Expiry Product'
];

export const ORDER_STATUS = [
  'PENDING',
  'ACTIVE',
  'INVOICED',
  'PAID',
  'READY_FOR_DISPENSING',
  'DISPENSING',
  'DISPENSED',
  'SHIPPING',
  'DELIVERED',
  'DELAYED',
  'CANCELLED',
  'INACTIVE',
  'PAYMENT_FAILED',
  'ON_HOLD'
];

export const PRODUCT_STATUS: string[] = ['ACTIVE', 'INACTIVE', 'DORMANT'];
export const PRODUCT_COMPOSITION = [
  {
    value: 'COMPOUNDED',
    label: 'Compounded'
  },
  {
    value: 'FINISHED_PRODUCT',
    label: 'Finished Product'
  }
];
export const CLINICAL_NOTES: ISelectOptions[] = [
  {
    value: 'HISTORY',
    label: 'History'
  },
  {
    value: 'CURRENTCONDITION',
    label: 'Current Condition'
  },
  {
    value: 'MEDICATIONS',
    label: 'Medications'
  },
  {
    value: 'PREVIOUSTHERAPY',
    label: 'Previous Therapy'
  },
  {
    value: 'GOALS',
    label: 'Goals'
  },
  {
    value: 'MENSTRUATION',
    label: 'Menstruation'
  },
  {
    value: 'FERTILITY',
    label: 'Fertility'
  },
  {
    value: 'SLEEP',
    label: 'Sleep'
  },
  {
    value: 'ENERGY',
    label: 'Energy'
  },
  {
    value: 'NUTRITION',
    label: 'Nutrition'
  },
  {
    value: 'GUTHEALTH',
    label: 'Gut Health'
  },
  {
    value: 'MENTALHEALTH',
    label: 'Mental Health'
  },
  {
    value: 'SOCIAL',
    label: 'Social'
  },
  {
    value: 'OTHER',
    label: 'Other'
  },
  {
    value: 'NEXTREVIEWDATE',
    label: 'Next Review Date'
  },
  {
    value: 'PINNEDALERTS',
    label: 'Pinned Alerts'
  },
  {
    value: 'IMPRESSIONS',
    label: 'Impressions'
  },
  {
    value: 'SEX',
    label: 'Sex'
  },
  {
    value: 'PLAN',
    label: 'Plan'
  },
  { label: 'Presenting Conditions / Symptoms', value: 'PRESENTINGCONDITION' },
  { label: 'Systems Review', value: 'SYSTEMSREVIEW' },
  { label: 'Patient Progress', value: 'PATIENTPROGRESS' },
  { label: 'Assessment', value: 'ASSESSMENT' }
];

export const ESCRIPT_TOKEN_STATUS_CX = {
  PENDING: {
    label: 'Pending',
    className: 'bg-yellow-500'
  },
  PROCESSING: {
    label: 'Processing',
    className: 'bg-yellow-500'
  },
  ACTIVE: {
    label: 'Active',
    className: 'bg-green-500'
  },
  INVOICED: {
    label: 'Invoiced',
    className: 'bg-[#8D3E30] text-white'
  },
  PAID: {
    label: 'Paid',
    className: 'bg-[#CE744B] text-white'
  },
  READY_FOR_DISPENSING: {
    label: 'Ready for Dispensing',
    className: 'bg-[#0F5342] text-white'
  },
  OVERDUE: {
    label: 'Overdue',
    className: 'bg-red-500'
  },
  DISPENSING: {
    label: 'Dispensing',
    className: 'bg-[#0F5342] text-white'
  },
  DISPENSED: {
    label: 'Dispensed',
    className: 'bg-[#0F5342] text-white'
  },
  SHIPPING: {
    label: 'Shipping',
    className: 'bg-green-500'
  },
  DELIVERED: {
    label: 'Delivered',
    className: 'bg-green-500'
  },
  INACTIVE: {
    label: 'Inactive',
    className: 'bg-green-500'
  },
  VOIDED: {
    label: 'Voided',
    className: 'bg-gray-400'
  },
  EXPIRED: {
    label: 'Expired',
    className: 'bg-red-500'
  },
  EXPORTED: {
    label: 'Exported',
    className: 'bg-green-500'
  },
  TRANSFERRED: {
    label: 'Transferred',
    className: 'bg-orange-400'
  },
  CANCELLED: {
    label: 'Cancelled',
    className: 'bg-gray-400'
  },
  ON_HOLD: {
    label: 'On hold',
    className: 'bg-green-500'
  }
};

export const INBOX_STATUS_FILTER: ISelectOptions[] = [
  { label: 'All Status', value: 'all' },
  { label: 'Pending Review', value: 'PENDING_REVIEW' },
  { label: 'Reviewed', value: 'REVIEWED' },
  { label: 'Completed', value: 'COMPLETED' }
];

export const INBOX_TYPE_FILTER: ISelectOptions[] = [
  { label: 'All Types', value: 'all' },
  { label: 'Referral', value: 'Referral' },
  { label: 'ID Document', value: 'ID Document' },
  { label: 'Letter', value: 'Letter' },
  { label: 'Results', value: 'Results' },
  { label: 'Other', value: 'Other' }
];

export const INBOX_PRIORITY_FILTER: ISelectOptions[] = [
  { label: 'All Priority', value: 'all' },
  { label: 'Urgent', value: 'URGENT' },
  { label: 'Non-urgent', value: 'NON_URGENT' }
];

export const INBOX_ASSIGNED_STAFF_FILTER: ISelectOptions[] = [
  { label: 'Dr. Smith', value: 'dr_smith' },
  { label: 'Nurse Amy', value: 'nurse_amy' },
  { label: 'Dr. Johnson', value: 'dr_johnson' }
];

export const INBOX_PRIORITY_OPTION: ISelectOptions[] = [
  { label: 'High', value: 'HIGH' },
  { label: 'Medium', value: 'MEDIUM' },
  { label: 'Low', value: 'LOW' }
];

export const INBOX_PRIORITY_OPTIONS: ISelectOptions[] = [
  { label: 'Urgent', value: 'URGENT' },
  { label: 'Non-urgent', value: 'NON_URGENT' }
];

export const REVIEW_RESULT_OPTIONS: ISelectOptions[] = [
  { label: 'Normal', value: 'NORMAL' },
  { label: 'Abnormal', value: 'ABNORMAL' }
];

export const INBOX_TYPE_OPTIONS: ISelectOptions[] = [
  { label: 'Referral', value: 'Referral' },
  { label: 'ID Document', value: 'ID Document' },
  { label: 'Letter', value: 'Letter' },
  { label: 'Results', value: 'Results' },
  { label: 'Others', value: 'Others' }
];

export const DATE_FORMATS = {
  DATE_MONTH_YEAR: 'dd/MM/yyyy', // THIS FORMAT IS USED FOR VALIDATE IHI, DON'T CHANGE, CREATE A NEW ONE IF YOU WANT A NEW FORMAT
  DATE_MONTH: 'dd/MM',
  MONTH_YEAR: 'MM/yyyy',
  FULL_DATE: 'dd MMM yyyy',
  DAY: 'EEEE',
  DAY_DATE_TIME: 'EE dd MMM hh:mmaa',
  DAY_DATE_TIME_WITH_YEAR: 'EE dd MMM yyyy hh:mmaa',
  DATE_TIME: 'dd/MM/yyyy hh:mmaa',
  DATE_TIME_WITH_SECONDS: 'dd/MM/yyyy hh:mm:ssaa',
  TIME: 'hh:mmaa',
  TIME_WITH_SECONDS: 'hh:mm:ssaa',
  TIME_24_HOUR: 'HH:mm',
  EXPORT_TIME: 'dd-MM-yyyy_hh:mm:ss',
  DAY_DATE_WITH_YEAR_FULL: 'EEEE dd MMMM yyy'
} as const;

export const TERPENES_PROFILE = [
  '3-Carene',
  'Alpha Bisabolol',
  'Alpha Bulnesene',
  'Alpha Cedrene',
  'Alpha Gurjunene',
  'Alpha Humulene',
  'Alpha Pinene',
  'Alpha Terpinene',
  'Alpha Terpineol',
  'Alpha-Phellandrene',
  'Aristolene',
  'Beta Caryophyllene',
  'Beta Farnesene',
  'Beta Maaliene',
  'Beta Myrcene',
  'Beta Pinene',
  'Beta Selinene',
  'Beta-Eudesmol',
  'Borneol',
  'Cadinene',
  'Calarene',
  'Camphene',
  'Camphor',
  'Caryophyllene',
  'Caryophyllene oxide',
  'Cedrol',
  'cis-Nerolidol',
  'd-Endo-Fenchyl',
  'D-Limonene',
  'Delta Guaiene',
  'Delta-3-Carene',
  'E-beta-Ocimene',
  'Eucalyptol',
  'Farnesene',
  'Fenchol',
  'Geraniol',
  'Geranyl Acetate',
  'Germacrene B',
  'Guaia-6,9-diene',
  'Guaiol',
  'Humulene',
  'Isopulegol',
  'Limonene',
  'Linalool',
  'Myrcene',
  'Nerolidol',
  'Ocimene',
  'Phytol',
  'Pinene',
  'R-Limonene',
  'Sabinene',
  'Selina-3,7(11)-diene',
  'Selina-4(15),7(11)-diene',
  'Terpineol',
  'Terpinolene',
  'Trans Caryophyllene',
  'trans-Nerolidol',
  'Valencene',
  'Z-beta-Ocimene'
];
export const PRODUCT_KIND: ISelectOptions[] = [
  {
    label: 'Accessories & Devices',
    value: 'DEVICE_ACCESSORY'
  },
  {
    label: 'Medicinal Cannabis',
    value: 'MEDICINAL_CANNABIS'
  },
  {
    label: 'Pharmaceuticals',
    value: 'PHARMACEUTICAL'
  },
  {
    label: 'Supplements',
    value: 'SUPPLEMENT'
  }
];

export const PRODUCT_SPECIES = ['Hybrid', 'Indica', 'Indica Dominant', 'Sativa', 'Sativa Dominant'];

export const SIZE_QUANTITY = ['g', 'gummies', 'mg', 'mL', 'units'];

export const PRODUCT_FORMS: string[] = [
  'Capsule',
  'Dried',
  'Extract, Concentrated',
  'Hash',
  'Inhalation',
  'Inhalation, pressurised',
  'Lozenge',
  'Oil Cartridge',
  'Oral liquid',
  'Pastille',
  'Patch',
  'Pessary',
  'Resin',
  'Spray',
  'Suppository',
  'Tablet',
  'Tablet, Chewable',
  'Topical',
  'Wafer'
];

export const DEFAULT_ROA = [
  'Inhalation via Vaporiser',
  'Inhalation',
  'Sublingual',
  'Oral',
  'Topical',
  'Transdermal',
  'Buccal Spray'
];

export const PRODUCT_SCHEDULE = ['S2', 'S3', 'S4', 'S8', 'NA'];
export const PRODUCT_CANNABINOID: string[] = ['CBC', 'CBG', 'CBN'];

export const PRODUCT_AVAILABILITY = [
  {
    label: 'In Stock',
    value: 'INSTOCK'
  },
  {
    label: 'Out of Stock',
    value: 'OUTOFSTOCK'
  },
  {
    label: 'Low Stock',
    value: 'LOWSTOCK'
  },
  {
    label: 'Discontinued',
    value: 'DISCONTINUED'
  },
  {
    label: 'Coming Soon',
    value: 'COMINGSOON'
  }
];

export const ESTIMATED_DELIVERY = ['1-3 Business Days', '2-5 Business Days'];
